import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { muiTheme } from './theme/muiTheme';
import Routes from './Routes';
import { RestaurantProvider } from './context/RestaurantContext';
import { AuthProvider } from './context/AuthContext';
import { OrderProvider } from './context/OrderContext';
import { QueueProvider } from './context/QueueContext';
import { CartProvider } from './context/CartContext';
import AuthModal from './components/dialogs/AuthModal';
import DevTools from './components/DevTools';
import GuestSignOutDialog from './components/dialogs/GuestSignOutDialog';
import { initializeFirebase } from './services/api/firebaseAdapter.jsx';

// Initialize Firebase at the app's root
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const useEmulator = import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true';

const emulatorConfig = useEmulator
  ? {
      host: import.meta.env.VITE_EMULATOR_HOST,
      authPort: parseInt(import.meta.env.VITE_EMULATOR_AUTH_PORT, 10),
      firestorePort: parseInt(import.meta.env.VITE_EMULATOR_FIRESTORE_PORT, 10),
      functionsPort: parseInt(import.meta.env.VITE_EMULATOR_FUNCTIONS_PORT, 10),
    }
  : {};

initializeFirebase(firebaseConfig, useEmulator, emulatorConfig);

const AppWrapper = () => {
  return (
    <RestaurantProvider>
      <QueueProvider>
        <CartProvider>
          <OrderProvider>
            <ThemeProvider theme={muiTheme}>
              <CssBaseline />
              <Routes />
              <AuthModal />
              <GuestSignOutDialog/>
              <DevTools />
            </ThemeProvider>
          </OrderProvider>
        </CartProvider>
      </QueueProvider>
    </RestaurantProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppWrapper />
    </AuthProvider>
  );
}

export default App;
